export default __webpack_public_path__ + "static/media/zagame-logo.405b3f9b.png";